import RadioButton from '@/features/ui/inputs/components/RadioButton'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'

interface CancelOrderDialogReturnMoneyRadioButtonsProps {
    disabled?: boolean
    returnMoney: boolean
    onReturnMoneyChange: (returnMoney: boolean) => void
}

const CancelOrderDialogReturnMoneyRadioButtons: FC<
    CancelOrderDialogReturnMoneyRadioButtonsProps
> = ({ disabled, returnMoney, onReturnMoneyChange }) => {
    const { t } = useTranslation()

    return (
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 8 }}>
            <RadioButton
                disabled={disabled}
                label={t('actions.yes')}
                checked={returnMoney}
                value="yes"
                onPress={() => onReturnMoneyChange(true)}
            />
            <RadioButton
                disabled={disabled}
                label={t('actions.no')}
                checked={!returnMoney}
                value="no"
                onPress={() => onReturnMoneyChange(false)}
            />
        </View>
    )
}

export default CancelOrderDialogReturnMoneyRadioButtons
